import { useRecoilValue } from 'recoil';
import * as atoms from '../atoms/atoms';
import useCachedEnvironments from './useCachedEnvironments';

const useEnvironment = (envId?: string) => {
  const selectedEnvId = useRecoilValue(atoms.selectedEnvironmentId);
  const { data: environmentsData } = useCachedEnvironments();
  const targetEnvId = envId ?? selectedEnvId;

  return environmentsData?.find((env) => env.id === targetEnvId);
};

export default useEnvironment;
